module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-05-6fb393b5604dfdd8f7e4f2b554e7d520.jpg";